import React from "react";
import SportsHeader from "../../images/common/SPORTS.png";
import "./Sections.css";
import { makeArticleCards } from "./utilities";


const SportsSection = () => {
  return (
    <div className="section" id='sports'>
      <div className="section-header">
        <img src={SportsHeader} alt="Sports" className="header-image" />
      </div>
      <div className="section-content sports-grid">
        {/* {makeArticleCards(9)} */}
        {makeArticleCards("sports_articles")}
      </div>
    </div>
  );
};

export default SportsSection;
